import React from "react";
import { NavDropdown } from "react-bootstrap";
import NavBarMB from "../../../assets/mork-borg/navbar-icon-morkborg.webp";
import NavBarMalumMortis from "../../../assets/mork-borg/malum-mortis-icon-85x85.webp";

const malumMortisSessionLinks = [
  {
    href: "/mork-borg-session-11-malum-mortis",
    label: "Malum Mortis: Session 11: 12-22-2023",
  },
  {
    href: "/mork-borg-session-10-malum-mortis",
    label: "Malum Mortis: Session 10: 12-08-2023",
  },
  {
    href: "/mork-borg-session-09-malum-mortis",
    label: "Malum Mortis: Session 09: 11-11-2023",
  },
  {
    href: "/mork-borg-session-08-malum-mortis",
    label: "Malum Mortis: Session 08: 10-06-2023",
  },
  {
    href: "/mork-borg-session-07-malum-mortis",
    label: "Malum Mortis: Session 07: 09-29-2023",
  },
  {
    href: "/mork-borg-session-06-malum-mortis",
    label: "Malum Mortis: Session 06: 08-25-2023",
  },
  {
    href: "/mork-borg-session-05-malum-mortis",
    label: "Malum Mortis: Session 05: 03-26-2023",
  },
  {
    href: "/mork-borg-session-04-malum-mortis",
    label: "Malum Mortis: Session 04: 03-26-2023",
  },
  {
    href: "/mork-borg-session-03-malum-mortis",
    label: "Malum Mortis: Session 03: 01-13-2023",
  },
  {
    href: "/mork-borg-session-02-malum-mortis",
    label: "Malum Mortis: Session 02: 01-06-2023",
  },
  {
    href: "/mork-borg-session-01-malum-mortis",
    label: "Malum Mortis: Session 01: 12-30-2022",
  },
];

const mapAndMiscLinks = [
  { href: "/mork-borg-malum-mortis-graveyard", label: "Graveyard" },
];

const rulesAndAidLinks = [
  { href: "/mork-borg-classes-gallery", label: "Class Gallery" },
  { href: "/mork-borg-classes-core", label: "Classes: Core" },
  { href: "/mork-borg-classes-third-party", label: "Classes: Third Party" },
];

const renderLinks = (links) =>
  links.map((item) => (
    <NavDropdown.Item key={item.href} href={item.href}>
      {item.label}
    </NavDropdown.Item>
  ));

const MorkBorgNavBar = () => {
  return (
    <NavDropdown title="Mork Borg" id="mork-borg-nav-dropdown">
      <NavDropdown.Header>
        <div style={{ textAlign: "center" }}>Malum Mortis Campaign</div>
      </NavDropdown.Header>
      <NavDropdown.Header>
        <img
          src={NavBarMalumMortis}
          alt="Malum Mortis"
          style={{ maxHeight: 85 }}
        />
      </NavDropdown.Header>

      <NavDropdown title="Sessions" id="mork-borg-sessions-dropdown">
        {renderLinks(malumMortisSessionLinks)}
      </NavDropdown>

      <NavDropdown title="Maps, Graveyard, Misc." id="mork-borg-maps-dropdown">
        {renderLinks(mapAndMiscLinks)}
      </NavDropdown>

      <NavDropdown.Divider />

      <NavDropdown.Header>
        <div style={{ textAlign: "center" }}>Mork Borg Game Aids</div>
      </NavDropdown.Header>
      <NavDropdown.Header>
        <img src={NavBarMB} alt="Mork Borg" style={{ maxHeight: 85 }} />
      </NavDropdown.Header>

      <NavDropdown title="Rules and Game Aids" id="mork-borg-rules-dropdown">
        {renderLinks(rulesAndAidLinks)}
      </NavDropdown>
    </NavDropdown>
  );
};

export default MorkBorgNavBar;
